// src/slices/toggleSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { getToggleState, setToggleState } from '../../services/storage/GQStorage';

const persistedState = getToggleState() || { toggle: true };

const toggleSlice = createSlice({
  name: 'toggle',
  initialState: persistedState,
  reducers: {
    setToggle: (state, action) => {
      state.toggle = action.payload;
    },
  },
});

export const { setToggle } = toggleSlice.actions;
export const toggleReducer = toggleSlice.reducer;

export const persistMiddleware = store => next => action => {
  const result = next(action);
  setToggleState(store.getState().setToggle);
  return result;
};

export default toggleSlice;
